// eslint-disable-next-line import/no-cycle
import { fetchCurrentUser } from '../services/user';
import $store from '../store';

async function setCurrentUserMiddleware(to, from) {
  const isLogged = $store.getters['auth/getIsLogged'];
  if (from && from.name === 'Login' && isLogged) {
    await fetchCurrentUser();
  }

  const user = $store.getters['user/getUser'];

  if (!user && isLogged) {
    await fetchCurrentUser();
  }
}

function verifyIsAuthMiddleware(to, from, next) {
  const isLogged = $store.getters['auth/getIsLogged'];
  if (to && to.meta && to.meta.isAuth && !isLogged) {
    return next({ path: '/login' });
  }

  if (to && to.name === 'Login' && isLogged) {
    return next({ path: '/dashboard' });
  }
}

async function verifyUserPermissionMiddleware(to, from, next) {
  if (
    to &&
    !['Login', 'Home', 'About', 'Goals', 'FAQ', 'Team'].includes(to.name)
  ) {
    await fetchCurrentUser();
  }
  const user = $store.getters['user/getUser'];
  if (to && to.meta && user && user.profileId && to.meta.allowedProfilesIds) {
    if (to.meta.allowedProfilesIds.indexOf(user.profileId) !== -1) {
      return next();
    }
    if (from && from.path) {
      return next({ path: from.path });
    }
    return next({ path: '/' });
  }
}

async function verifyUserHasApprovedLgpdMiddleware(to, from, next) {
  if (
    to &&
    !['Login', 'Home', 'About', 'Goals', 'FAQ', 'Team'].includes(to.name)
  ) {
    await fetchCurrentUser();
  }
  const user = $store.getters['user/getUser'];
  if (
    user &&
    !user.hasApprovedLgdp &&
    to &&
    to.meta &&
    to.name !== 'Dashboard' &&
    to.meta.isAuth
  ) {
    console.log('redireciona dashboard!');
    return next({ path: '/dashboard' });
  }
  return next();
}

function verifyExistRoute(to, from, next) {
  if (to && !to.name) {
    return next({ path: '/' });
  }
  return next();
}

export async function routerMiddlewares(to, from, next) {
  await setCurrentUserMiddleware(to, from, next);
  verifyIsAuthMiddleware(to, from, next);
  await verifyUserPermissionMiddleware(to, from, next);
  await verifyUserHasApprovedLgpdMiddleware(to, from, next);
  verifyExistRoute(to, from, next);
  return next();
}
